// packages/utils/src/shared/net/tourtaskOrigins.ts
//
// The two TourTask hosts that a page running one of our widgets connects to, in production. They are one server in
// Los Angeles with no CDN, so each new connection costs a visitor in Europe 0.65-0.74 s of TCP and TLS set-up, which a
// `<link rel="preconnect">` can start early (docs/embed-size-and-speed.md §6.1 #1 and #2):
// - the API: the widgets' `/v1` base is built from TOURTASK_API_ORIGIN (packages/storefront/src/api/baseUrls.ts, which
//   switches to the local API on the dev machine), and the pages that load a widget hint at it;
// - the photos: their URLs come from the server, never from here (the boot answer's `urls.media` in the widgets,
//   NEXT_PUBLIC_MEDIA_URL in the apps; getTourImageUrl). The widget's hint goes out seconds before that answer
//   arrives, so it names the production host itself. If the media host ever moves, change this with
//   NEXT_PUBLIC_MEDIA_URL: until then a stale hint only opens a connection nothing uses, and the photos still load
//   from the host the answer names.

/** The TourTask API in production (scheme and host, no path). */
export const TOURTASK_API_ORIGIN = 'https://api.tourtask.com';

/** The media host the photos are served from in production. For connection hints only: see the header. */
export const TOURTASK_MEDIA_ORIGIN = 'https://media.tourtask.com';
